const landingPages = new Set(['/tjana-pengar-till-studenten','/salja-med-klassen','/tjana-pengar-till-klassresan', '/tjana-pengar-till-laget', '/klassforsaljning', '/tjana-pengar-till-foreningen']);
let registrationLanding;
export function rememberLandingPage(path) {
  const normalized = path.replace(/\/$/, '');
  // Keep a guide-origin registration through the explicit class-page funnel.
  if (["/tjana-pengar-till-studenten","/salja-med-klassen","/tjana-pengar-till-klassresan"].includes(registrationLanding) && normalized === "/klassforsaljning") return;
  if (landingPages.has(normalized)) registrationLanding = normalized;
}
export function getRegistrationLanding() {
  if (registrationLanding) return registrationLanding;
  try {
    const referrer = new URL(document.referrer);
    if (referrer.origin === window.location.origin) rememberLandingPage(referrer.pathname);
  } catch { /* No same-origin landing referrer. */ }
  return registrationLanding;
}
